module.exports = __webpack_public_path__ + "img/title2.8dc9ce7c.png";